import { findRecursive } from '@/mm/utils.js'
import { washDataArabic, washDataArabicAlign, ArabicEach } from '@/mm/utils.js'
import { createMuiltLanguagesJson } from "@/components/widgets/nav/repeatNumber.js";

export function washData_relatedCarouselProduct(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'text_title',
    'list'
  )
  if (walkedNode._type === 'related_carousel_product1') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)

  } else if (walkedNode._type === 'related_carousel_product2') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_product3') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_product4') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    getNodeByFlag(walkedNode,'abstract').forceShowEye = true
    let ArabicRule = [
      {
        flag: 'name',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'abstract',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'related_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
  } else if (walkedNode._type === 'related_carousel_product5') {
    let ArabicRule = [
      {
        flag: 'product5_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    if(walkedNode.editStyle){
      ArabicRule.forEach((item,index)=>{
        console.log(walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish])
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
    }
  } else if (walkedNode._type === 'related_carousel_product7') {
    let ArabicRule = [
      {
        flag: 'product7_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product7_list_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product7_paragraph',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    if(walkedNode.editStyle){
      ArabicRule.forEach((item,index)=>{
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
    }
  } else if (walkedNode._type === 'related_carousel_product8') {
    let ArabicRule = [
      {
        flag: 'product8_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product8_list_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product8_list_paragraph',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    let ArabicRule2 = [
      {
        flag: 'product8_list_button',
        dataType: ['design'],
        onlyEnglish: ['self_marginLeft'],
        englishTitleLeft: ['24'],
        englishTitleRight: ['0'],
      },
      {
        flag: 'product8_list_button',
        dataType: ['design'],
        onlyEnglish: ['self_marginRight'],
        englishTitleLeft: ['0'],
        englishTitleRight: ['24'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    if(walkedNode.editStyle){
      ArabicRule.forEach((item,index)=>{
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
      ArabicRule2.forEach((item,index)=>{
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
    }
  } else if (walkedNode._type === 'related_carousel_product9') {
    let ArabicRule = [
      {
        flag: 'product9_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product9_list_title',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      },
      {
        flag: 'product9_list_paragraph',
        dataType: ['design'],
        onlyEnglish: ['title_textAlign'],
        englishTitleLeft: ['left'],
        englishTitleRight: ['right'],
      }
    ]
    let ArabicRule2 = [
      {
        flag: 'product8_list_button',
        dataType: ['design'],
        onlyEnglish: ['self_marginLeft'],
        englishTitleLeft: ['24'],
        englishTitleRight: ['0'],
      },
      {
        flag: 'product8_list_button',
        dataType: ['design'],
        onlyEnglish: ['self_marginRight'],
        englishTitleLeft: ['0'],
        englishTitleRight: ['24'],
      }
    ]
    ArabicEach(walkedNode, ArabicRule)
    if(walkedNode.editStyle){
      ArabicRule.forEach((item,index)=>{
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
      ArabicRule2.forEach((item,index)=>{
        if(typeof walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish].diannao ==='object')return
        walkedNode.editStyle[item.flag][item.dataType][item.onlyEnglish] = {
          diannao:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          pingban:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight}),
          shouji:createMuiltLanguagesJson(item.englishTitleLeft,{'rtl': item.englishTitleRight})
        }
      })
    }
  }
}
